import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23de3d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Вход", -1))
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = ["href"]

import ButtonCustom from '../UI/ButtonCustom.vue';
    import {ref} from 'vue'
    import { useNotification } from "@kyvg/vue3-notification";
    import handleError from '@/tools/errorHandler'
    import {API} from '@/api/modules/auth'
    import { useStore } from 'vuex';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginModule',
  emits: ['closeAuth'],
  setup(__props, { emit }) {

    const store = useStore()
    const { notify }  = useNotification()
    

    let login = ref('')
    let password = ref('')

    function defaultLogin(){
        API.login(login.value, password.value)
            .then( res => {
                store.commit('setUserName', login.value)
                store.commit('setToken', res.data.token)
                emit('closeAuth')
            })
            .catch(err => handleError(err))
    }

    console.log(process.env.VUE_APP_VK_CLIENT_ID)
    console.log(process.env.VUE_APP_VK_REDIRECT_URI)

    let vk =  {
        client_id: process.env.VUE_APP_VK_CLIENT_ID,
        redirect_uri: process.env.VUE_APP_VK_REDIRECT_URI,
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      class: "auth-input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(login) ? (login).value = $event : login = $event)),
      placeholder: "Логин или имя"
    }, null, 512), [
      [_vModelText, _unref(login)]
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "auth-input",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
      placeholder: "Пароль",
      type: "password"
    }, null, 512), [
      [_vModelText, _unref(password)]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ButtonCustom, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (defaultLogin()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Войти")
        ]),
        _: 1
      }),
      _createVNode(ButtonCustom, null, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            href: `https://oauth.vk.com/authorize?client_id=${_unref(vk).client_id}&display=page&response_type=code&redirect_uri=${_unref(vk).redirect_uri}`
          }, "Войти через ВК", 8, _hoisted_3)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", null, [
      _createTextVNode("Перейти на "),
      _createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleAuth')))
      }, "регистрацию")
    ])
  ]))
}
}

})